<template>
  <div class="container">
    <div class="bgoverlay">
      <div class="bg" :style="{'background-image': `url(${require('@/assets/images/partner.jpg')})`}"></div>
    </div>
    <div class="inner-pannel">
    <!-- <div class="main-box"> -->
      <div class="pannel-content">
        <div class="pannel-content-box maxwidth-lg topPoint">
          <div class="content-page">
               <div style="width:100%;height:150px;padding-top:50px;">
                    <dynamic-marquee direction="row" :speed="{type: 'pps',number: 150}">
                         <div style="width:780px;">
                         <img src="../../assets/images/company2-1.png" style="width: 150px;display:inline-block;">
                         <img src="../../assets/images/company1.png" style="width: 150px;display:inline-block;">
                         <img src="../../assets/images/company3.png" style="width: 150px;display:inline-block;">
                         <img src="../../assets/images/company4.png" style="width: 150px;display:inline-block;">
                         <img src="../../assets/images/company7.png" style="width: 150px;display:inline-block;">
                         </div>
                    </dynamic-marquee>
               </div>
               <div style="width:100%;height:100px;padding-bottom: 0;">
                    <dynamic-marquee direction="row" :speed="{type: 'pps',number: 120}">
                         <div style="width:780px;">
                         <img src="../../assets/images/company16.png" style="width: 150px;display:inline-block;">
                         <img src="../../assets/images/company31.png" style="width: 150px;display:inline-block;">
                         <img src="../../assets/images/company32.png" style="width: 150px;display:inline-block;">
                         <img src="../../assets/images/company17.png" style="width: 150px;display:inline-block;">
                         <img src="../../assets/images/company18.png" style="width: 150px;display:inline-block;">
                         </div>
                    </dynamic-marquee>
               </div>
               <div style="width:100%;height:100px;padding-bottom: 0;">
                    <dynamic-marquee direction="row" :speed="{type: 'pps',number: 100}">
                         <div style="width:930px">
                         <img src="../../assets/images/company19.png" style="width: 150px;display:inline-block;">
                         <img src="../../assets/images/company22.png" style="width: 150px;display:inline-block;">
                         <img src="../../assets/images/company24.png" style="width: 150px;display:inline-block;">
                         <img src="../../assets/images/company27.png" style="width: 150px;display:inline-block;">
                         <img src="../../assets/images/company33.png" style="width: 150px;display:inline-block;">
                         <img src="../../assets/images/company34.png" style="width: 150px;display:inline-block;">
                         </div>
                    </dynamic-marquee>
               </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default ({
  data() {
    return{}
  },
})
</script>

<style scoped>
    .inner-pannel{
        min-height: 100%;
        padding-bottom: 150px;
        position: static;
        /* position: relative; */
        /* position: absolute; */
        top: 0;
        width: 100%;
        font-family: 'Lato','Microsoft JhengHei';
    }
    .pannel-content .pannel-content-box{
         padding: 0;
    }
    .bgoverlay::before{
        background: transparent;
    }
    .content{
        display: flex;
        flex-wrap: wrap;
    }
    .item-text{
        text-align: center;
    }
    .content-item1{
        text-align: center;
        width: calc(100% / 6);
        margin-bottom: 10px;
    }
    .content-item1 img{
        width: 100%;
    }
    .content-item2 img{
        width: 100%;
    }
    .content-item3 img{
        width: 100%;
    }
    .line-box{
        display: block;
        margin-top: 8px;
        width: 55%;
        border-bottom: 1px solid #ffffff;
    }
    .main{
        margin: 8px 0;
    }
     .topPoint::after {
        width: 25px;
        height: 25px;
        content: "";
        position: absolute;
        background: #ed6d00;
        border-radius: 50%;
        z-index: 1;
        top: -12.5px;
        right: -12.5px;
    }
</style>


// WEBPACK FOOTER //
// src/components/industryPartners/industryPartners.vue